import script from "./ShopCard.vue?vue&type=script&setup=true&lang=js"
export * from "./ShopCard.vue?vue&type=script&setup=true&lang=js"

import "./ShopCard.vue?vue&type=style&index=0&id=1c2c46eb&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1c2c46eb"]])

export default __exports__